<div class="flex items-center justify-center min-h-screen">
  <div class="text-center p-8" role="status" aria-live="polite">
    <i
      class="fa-solid fa-spinner fa-spin text-4xl text-jamaica-green-600 mb-4"
      aria-hidden="true">
    </i>
    <p class="text-gray-700 dark:text-gray-300 text-lg">
      Finalizing your subscription changes, please wait...
    </p>
  </div>
</div>